/* unplugin-vue-components disabled */import script from "./selectTree.vue?vue&type=script&setup=true&lang=js"
export * from "./selectTree.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__